export const SYSTEM_STATUS = 'system_status';
export const BATTERY_STATUS = 'battery_status';
export const CYCLE_FRAME = 'cycle_frame';
